// extracted by mini-css-extract-plugin
export default {"customMenu":"menu_customMenu__k8tCx"};